import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();
const { projectCode } = PROJECT_CODE;

export async function updateBuildingInfoAllElevationsPrice(
	buildingId,
	priceChange,
	alteredBy
) {
	let BuildingPriceRef = firebaseRef.ref(
		'/kavtek_buildingInfo/' + projectCode + '/' + buildingId + '/priceList'
	);

	BuildingPriceRef.once('value', (snapshot) => {
		snapshot.forEach((childSnapshot) => {
			let finalPrice =
				Number(childSnapshot.val().price) + Number(priceChange);
			let elevationRef = firebaseRef.ref(
				'/kavtek_buildingInfo/' +
					projectCode +
					'/' +
					buildingId +
					'/priceList/' +
					childSnapshot.key
			);
			elevationRef
				.update({
					price: finalPrice,
				})
				.then(() => {
					if (Number(priceChange) !== 0) {
						let timestampRef = firebaseRef.ref(
							'/kavtek_timestamps/' +
								projectCode +
								'/siteplan/buildingInformation'
						);
						let timestamp = timestampRef.push();
						timestamp.set({
							timestamp: Date.now(),
							oldValue: Number(childSnapshot.val().price),
							newValue: finalPrice,
							buildingId: buildingId,
							elevationId: childSnapshot.val().id,
							alteredBy: alteredBy,
						});
					}
				});
		});
	});
}

export async function updateBuildingInfoSingleElevationPrice(
	buildingId,
	elevationId,
	price,
	alteredBy
) {
	let BuildingPriceRef = firebaseRef.ref(
		'/kavtek_buildingInfo/' + projectCode + '/' + buildingId + '/priceList'
	);
	BuildingPriceRef.orderByChild('id')
		.equalTo(elevationId)
		.once('value', async (snapshot) => {
			let priceListKey;
			snapshot.forEach((childSnapshot) => {
				priceListKey = childSnapshot.key;
			});

			if (priceListKey !== undefined) {
				let priceRef = firebaseRef.ref(
					'/kavtek_buildingInfo/' +
						projectCode +
						'/' +
						buildingId +
						'/priceList/' +
						priceListKey
				);
				let oldValues;
				await priceRef.once('value', (snapshot) => {
					oldValues = {
						price: snapshot.val()?.price,
					};
				});
				await priceRef.update({
					price: Number(price),
				});
				if (Number(oldValues.price) !== Number(price)) {
					let timestampRef = firebaseRef.ref(
						'/kavtek_timestamps/' +
							projectCode +
							'/siteplan/buildingInformation'
					);
					let timestamp = timestampRef.push();
					await timestamp.set({
						timestamp: Date.now(),
						oldValue: Number(oldValues.price),
						newValue: Number(price),
						buildingId: buildingId,
						elevationId: elevationId,
						alteredBy: alteredBy,
					});
				}
			}
		});
}

export async function updateBuildingInfoSingleElevationImg(
	buildingId,
	elevationId,
	imageFileArr
) {
	let imgArr = [];
	let elevationToLower = elevationId?.toLowerCase();
	for (let item of imageFileArr) {
		if (item.file.onCloud) {
			// the image has been stored on cloud
			imgArr.push({
				url: item.url,
				name: item.file.name,
			});
		} else {
			// the image is newly created
			let storage = firebase
				.storage()
				.ref(
					projectCode +
						'/buildingExteriors/' +
						buildingId +
						'/' +
						elevationToLower +
						'/' +
						item.file.name
				);
			await storage.put(item.file);
			let url = await storage.getDownloadURL();
			if (url) {
				imgArr.push({
					url: url,
					name: item.file.name,
				});
			}
		}
	}

	let BuildingPriceRef = firebaseRef.ref(
		'/kavtek_buildingInfo/' + projectCode + '/' + buildingId + '/priceList'
	);
	BuildingPriceRef.orderByChild('id')
		.equalTo(elevationId)
		.once('value', (snapshot) => {
			let priceListKey;
			snapshot.forEach((childSnapshot) => {
				priceListKey = childSnapshot.key;
			});

			if (priceListKey !== undefined) {
				let priceRef = firebaseRef.ref(
					'/kavtek_buildingInfo/' +
						projectCode +
						'/' +
						buildingId +
						'/priceList/' +
						priceListKey
				);
				priceRef.update({
					images: imgArr,
				});
			}
		});
}

export async function updateBuildingInfoSingleElevationFloorplan(
	buildingId,
	elevationId,
	imageFileArr
) {
	let imgArr = [];
	for (let item of imageFileArr) {
		if (item.file.onCloud) {
			// the file has been stored on cloud
			imgArr.push({
				url: item.url,
				name: item.file.name,
			});
		} else {
			// the file is newly created
			let storage = firebase
				.storage()
				.ref(
					projectCode +
						'/floorPlans/' +
						buildingId +
						'/' +
						elevationId +
						'/' +
						item.file.name
				);
			await storage.put(item.file);
			let url = await storage.getDownloadURL();
			if (url) {
				imgArr.push({
					url: url,
					name: item.file.name,
				});
			}
		}
	}

	let BuildingPriceRef = firebaseRef.ref(
		'/kavtek_buildingInfo/' + projectCode + '/' + buildingId + '/priceList'
	);
	BuildingPriceRef.orderByChild('id')
		.equalTo(elevationId)
		.once('value', (snapshot) => {
			let priceListKey;
			snapshot.forEach((childSnapshot) => {
				priceListKey = childSnapshot.key;
			});

			if (priceListKey !== undefined) {
				let priceRef = firebaseRef.ref(
					'/kavtek_buildingInfo/' +
						projectCode +
						'/' +
						buildingId +
						'/priceList/' +
						priceListKey
				);
				priceRef.update({
					floorplanFiles: imgArr,
				});
			}
		});
}

export async function updateBuildingInfoSingleElevationOptions(
	buildingId,
	elevationId,
	options
) {
	let newOptions = JSON.parse(JSON.stringify(options));
	for (let index = 0; index < options?.length; index++) {
		let imgArr = [];
		if (options[index]?.images) {
			for (let item of options[index]?.images) {
				if (item.file?.onCloud) {
					imgArr.push({
						url: item.url,
						name: item.file.name,
					});
				} else {
					let storage = firebase
						.storage()
						.ref(
							projectCode +
								'/elevationOptions/' +
								buildingId +
								'/' +
								elevationId +
								'/' +
								index +
								'/' +
								item.file.name
						);
					await storage.put(item.file);
					let url = await storage.getDownloadURL();
					if (url) {
						imgArr.push({
							url: url,
							name: item.file.name,
						});
					}
				}
			}
		}
		newOptions[index].images = imgArr;
	}

	let BuildingPriceRef = firebaseRef.ref(
		'/kavtek_buildingInfo/' + projectCode + '/' + buildingId + '/priceList'
	);
	BuildingPriceRef.orderByChild('id')
		.equalTo(elevationId)
		.once('value', (snapshot) => {
			let priceListKey;
			snapshot.forEach((childSnapshot) => {
				priceListKey = childSnapshot.key;
			});

			if (priceListKey !== undefined) {
				let priceRef = firebaseRef.ref(
					'/kavtek_buildingInfo/' +
						projectCode +
						'/' +
						buildingId +
						'/priceList/' +
						priceListKey
				);
				priceRef.update({
					options: newOptions,
				});
			}
		});
}
